import { useApiState } from 'hooks/useApiState';
import { useAppState } from 'hooks/useAppState';
import { useState, type JSX } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import { submit } from 'utils/app';

export default function DashboardLayoutNavbarLogout(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const { showBoundary } = useErrorBoundary();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const [acctState] = useAtom(AcctState);
  const { signOutRequest } = useAppState();
  const { handleSubmit } = useForm();
  const { postProxyLogout } = useApiState();
  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * 編集リンククリック時の処理
   */
  const onSignOut = () => {
    submit(
      processing,
      setProcessing,
      handleSubmit(async () => {
        try {
          if (acctState.proxyLogin) {
            await postProxyLogout({});
            window.close();
          } else {
            await signOutRequest();
            navigate('/');
          }
        } catch (e: unknown) {
          showBoundary(e);
        }
      })
    );
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <div className="text-center">
      <a className="btn btn-logout" onClick={onSignOut}>
        <img src="/img/icon/logout.svg" alt="ログアウト" />
        ログアウト
      </a>
    </div>
  );
}
